<template>
  <div class="main" @click="openSecretMenu">
    <Vidle v-show="false" :duration="120" @idle="onIdle" @refresh="onRefresh" />
    <IdleScreenComponent />
    <div v-if="secretMenu" class="dev-infos">
      UID : {{ uid }}<br />
      IDLE: {{ isIdle }}<br />
      Ranges: {{ Object.keys(ranges).length }}<br />
      Initialized: {{ initialized }}<br />
      Counter: {{ counter }}<br />
      Loading: {{ loading }}<br />
      Ping state: {{ pingState }}<br />
      Background: {{ background }}<br />
      <button type="button" @click="reload">Reload</button>
      <button type="button" @click="initApp">Init</button>
    </div>
    <router-view v-slot="{ Component }">
      <transition
        :mode="$route.meta.mode || 'in-out'"
        :name="$route.meta.transition || 'fade'"
      >
        <div :key="$route.path" class="h-100 w-100 overflow-hidden">
          <component :is="Component" />
        </div>
      </transition>
    </router-view>
    <NavComponent />
    <LoaderComponent />
    <div id="preload" class="d-none"></div>
  </div>
</template>

<script>
import { useMeta } from "@/composables/use-meta";
import { mapActions, mapState } from "pinia";
import "@/assets/style/app.scss";
import { timeoutManager } from "@/services/timeout-manager";
import { useMainStore } from "@/store";
import NavComponent from "@/components/NavComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import Vidle from "v-idle";
import IdleScreenComponent from "@/components/IdleScreenComponent.vue";

export default {
  name: "App",
  components: { IdleScreenComponent, LoaderComponent, NavComponent, Vidle },
  data() {
    return {
      clickCount: 0,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      transitionMode: (store) => store.transitionMode,
      uid: (store) => store.uid,
      isIdle: (store) => store.isIdle,
      ranges: (store) => store.ranges,
      counter: (store) => store.counter,
      loading: (store) => store.loading,
      pingState: (store) => store.pingState,
      initialized: (store) => store.initialized,
      secretMenu: (store) => store.secretMenu,
      background: (store) => store.background,
    }),
  },
  watch: {
    isIdle() {
      timeoutManager.watchActivity();
      timeoutManager.watchUpdate();
    },
    initialized() {
      timeoutManager.watchUpdate();
    },
    $route() {
      timeoutManager.watchUpdate();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!localStorage.getItem("aixam-login")) {
        this.$router.push({ name: "Login" });
      } else {
        this.$router.push({ name: "Home" });
      }
      this.setMeta();
      this.setUid();
      timeoutManager.watchUpdate();
      document.onvisibilitychange = () => {
        this.setBackground(document.visibilityState === "hidden");
      };
    },

    reload() {
      location.href = "/";
    },

    initApp() {
      localStorage.clear();
      location.href = "/";
    },

    setUid() {
      let uid = window.localStorage.getItem("aixam-device-uid");
      if (!uid) {
        uid = this.createUniquid();
      }
      this.setStoreUid(uid);
    },

    createUniquid() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },

    setMeta() {
      useMeta({ title: this.$route.meta.title });
    },

    onIdle() {
      this.setIdle(true);
    },

    onRefresh() {
      this.setIdle(false);
    },

    openSecretMenu() {
      if (!this.clickCount) {
        setTimeout(() => {
          this.clickCount = 0;
        }, 1000);
      }
      this.clickCount++;
      if (this.clickCount === 5) {
        this.setSecretMenu(true);
        setTimeout(() => {
          this.setSecretMenu(false);
        }, 10000);
      }
    },

    ...mapActions(useMainStore, [
      "setStoreUid",
      "setIdle",
      "setDomain",
      "setSecretMenu",
      "setBackground",
    ]),
  },
};
</script>

<style lang="scss">
@import "assets/style/app";

.dev-infos {
  position: fixed;
  top: 0;
  right: 0;
  color: $white;
  z-index: 100000;
  width: auto;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.2);
  padding: 10px;
}
</style>
